export default "__VITE_ASSET__C2LwFw7G__"